import React from 'react';
import { isSafari, isIOS } from 'react-device-detect';
import { Box, Typography } from '@mui/material';
import LandscapePaperLayout from '../@common/landscape/LandscapePaperLayout';
import LandscapeCompletionBorder from 'html-worksheets/@common/landscape/LandscapeCompletionBorder';
import BaseInput from '../@common/BaseInput';
import CertificateImageBody from 'html-worksheets/@common/landscape/CertificateImageBody';
import SignAndDate from 'html-worksheets/@common/SignAndDate';
import PageLines from '../@common/PageLines';
import { WorksheetBaseProps } from 'html-worksheets/@types';
import { determineStyleBasedOnLineWidth } from '../../utils/style-utils';
import { translate } from '../../translations/translator';
const t = key => translate('worksheet', key);

type CompletionCertificateProps = WorksheetBaseProps & {
  completedTitle: string;
  isCursive?: boolean;
  images: any;
  isOneLine?: boolean;
  isWide?: boolean;
  printRef?: React.RefObject<HTMLDivElement>;
};

const baseStyles = {
  fontFamily: 'Futura-Semibold'
};

const CompletionCertificate = ({
  onChange,
  completedTitle,
  isCursive,
  images,
  isOneLine,
  isWide,
  valueMap,
  printRef
}: CompletionCertificateProps) => {
  const handleChange = ({ target }) => {
    onChange({
      1: target.value
    });
  };
  const isNarrow = false;
  let fontSize = determineStyleBasedOnLineWidth(
    isCursive,
    isNarrow,
    {
      wide: 61,
      cursiveAndNarrow: 51,
      narrow: 51,
      cursive: 51,
      regular: 40
    },
    isWide
  );
  let letterSpacing;
  let textTransform;

  if (isOneLine) {
    letterSpacing = 15;
    textTransform = 'uppercase';
  }

  const marginTop = determineStyleBasedOnLineWidth(
    isCursive,
    isNarrow,
    {
      wide: '-44px',
      cursiveAndNarrow: isSafari || isIOS ? '0px' : '-18px',
      narrow: '-18px',
      cursive: isSafari || isIOS ? '-18px' : '-33px',
      regular: '-30px'
    },
    isWide
  );

  return (
    <LandscapePaperLayout isWide={isWide} noFooterText printRef={printRef}>
      <LandscapeCompletionBorder title={t('youDidIt')}>
        <Box display="flex" justifyContent="center" sx={{ marginTop: '-45px' }}>
          <Typography variant="h2" sx={{ ...baseStyles, fontSize: 24, fontWeight: 'bold' }}>
            {t('congratulations')},
          </Typography>
        </Box>
        <PageLines
          width={900}
          isWide={isWide}
          isOneLine={isOneLine}
          style={{ marginTop: '30px' }}
          paddingTop={isWide ? 30 : 0}
        >
          <BaseInput
            showBackground={true}
            onChange={handleChange}
            fontFamily={isCursive ? 'Cursive-Book' : 'Print-Wide-Book'}
            color="#000"
            placeholder={t('enterName')}
            style={{
              textAlign: 'center',
              letterSpacing: letterSpacing,
              textTransform: textTransform
            }}
            fontSize={fontSize}
            marginTop={marginTop}
            width={900}
            value={valueMap[1]}
          />
        </PageLines>
        <CertificateImageBody images={images} completedTitle={completedTitle} />
        <SignAndDate />
      </LandscapeCompletionBorder>
    </LandscapePaperLayout>
  );
};

export default CompletionCertificate;
